const kindOfPropertyOptions = [
  {
    key: 'PROPIETAIRE',
    literal: 'furniture.kindOfPropertyOptions.owner'
  },
  {
    key: 'LOCATAIRE',
    literal: 'furniture.kindOfPropertyOptions.renter'
  }
]

export { kindOfPropertyOptions }
